<h2 mat-dialog-title>
  <mat-icon>person</mat-icon>
  Cadastro do paciente
</h2>

<mat-dialog-content>
  <p class="dialog-intro">
    Cadastro básico para iniciar a jornada — conforme alinhado com a equipe médica, <strong>nome, CPF, telefone e
    e-mail</strong> bastam, já que o paciente já está captado.
  </p>

  <div class="fields-grid">
    <mat-form-field appearance="outline">
      <mat-label>Nome</mat-label>
      <input matInput [ngModel]="patient().nome" (ngModelChange)="update('nome', $event)" required />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>CPF</mat-label>
      <input matInput [ngModel]="patient().cpf" (ngModelChange)="update('cpf', $event)" required />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Telefone</mat-label>
      <input matInput [ngModel]="patient().telefone" (ngModelChange)="update('telefone', $event)" required />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput [ngModel]="patient().email" (ngModelChange)="update('email', $event)" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="field-wide">
      <mat-label>Queixa principal</mat-label>
      <textarea matInput rows="2" [ngModel]="patient().queixaPrincipal" (ngModelChange)="update('queixaPrincipal', $event)"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Médico responsável</mat-label>
      <input matInput [ngModel]="patient().medicoResponsavel" (ngModelChange)="update('medicoResponsavel', $event)" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Início do tratamento</mat-label>
      <input matInput type="date" [ngModel]="patient().dataInicioTratamento" (ngModelChange)="update('dataInicioTratamento', $event)" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()">Fechar</button>
</mat-dialog-actions>
